<template>
  <div :id="`loadableContent-comments-${node.id}`" class="textarea-emoji-picker" v-click-outside="hideEmojiPicker">
    <picker
      :data="emojiIndex"
      v-show="showEmojiPicker"
      title="Pick your emoji..."
      emoji="point_up"
      @select="addEmoji"
    />
    <span
      class="emoji-trigger"
      :class="{ 'triggered': showEmojiPicker }"
      @click="toggleEmojiPicker"
    >
      <svg
        style="width:20px;height:20px"
        viewBox="0 0 24 24"
      >
        <path fill="#888888" d="M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z" />
      </svg>
    </span>
    <!--<vs-textarea
      v-validate="'required'"
      :class="{'input': true,
        'is-danger': errors.has('posts.title') }"
      vs-size="large"
      color="#B20564"
      name="title"
      class="inputx"
      :placeholder="$t('dash.posts.overlay.description_placeholder')"
      v-model="form.title"
      ref="inputTitle"
    />-->
    <vs-input
      v-validate="'required'"
      :class="{'input': true }"
      vs-size="large"
      color="#B20564"
      type="text"
      name="message"
      class="inputx"
      :placeholder="$t('dash.posts.overlay.description_placeholder')"
      v-model="message"
      ref="inputTitle"
      @keyup.enter.native="onSubmitComment"
    />
  </div>
</template>

<script>
import moment from 'moment'
import Moderation from './../mixins/Moderation'
import emojiData from 'emoji-mart-vue-fast/data/all.json'
import { Picker, EmojiIndex  } from 'emoji-mart-vue-fast'
import 'emoji-mart-vue-fast/css/emoji-mart.css'
import ClickOutside from 'vue-click-outside'

export default {
  name: 'message-comment',

  mixins: [Moderation],

  components: {
    Comment,
    Picker,
  },

  directives: {
    ClickOutside
  },

  props: {
    page: Object,
    node: Object,
    inbox: Object
  },

  data() {
    return {
      message: null,
      showEmojiPicker: false,
      emojiIndex: new EmojiIndex(emojiData),
    }
  },

  mounted(){
    
  },

  methods: {
    onSubmitComment(){
      if(this.inbox) {
        this.$emit('onSubmitComment', this.node.id, this.message)
        this.message = null
        return
      }

      this.$vs.loading({
        //background: 'primary',
        color: 'primary',
        container: `#loadableContent-comments-${this.node.id}`
      })
      if(this.page.network == "facebook")
      {
      this.addComment(this.page, this.node.id, this.message).then(res => {
        this.$vs.loading.close(`#loadableContent-comments-${this.node.id} > .con-vs-loading`)
        const { success } = res.body

        if (!success || success !== true) {
          this.dialog.title = 'Error'
          if (!res.body) {
            this.dialog.message = 'Server not responding…'
          } else {
            this.dialog.message = res.body.statusText
          }
          this.dialog.show = true
          return
        }
        this.message = null
        this.$emit('getComments')
      })
      }
      if(this.page.network == "instagram"){
        console.log('node',this.node)
        if(this.node.ig_id){
          console.log("ig_id true")
          this.addCommentPost(this.page, this.node.id, this.message).then(res => {
          this.$vs.loading.close(`#loadableContent-comments-${this.node.id} > .con-vs-loading`)
          const { success } = res.body

          if (!success || success !== true) {
            this.dialog.title = 'Error'
            if (!res.body) {
              this.dialog.message = 'Server not responding…'
            } else {
              this.dialog.message = res.body.statusText
            }
            this.dialog.show = true
            return
          }
          this.message = null
          this.$emit('getComments')
        })
        }
        else{
          console.log('ig_id false')
          this.addComment(this.page, this.node.id, this.message).then(res => {
          this.$vs.loading.close(`#loadableContent-comments-${this.node.id} > .con-vs-loading`)
          const { success } = res.body

          if (!success || success !== true) {
            this.dialog.title = 'Error'
            if (!res.body) {
              this.dialog.message = 'Server not responding…'
            } else {
              this.dialog.message = res.body.statusText
            }
            this.dialog.show = true
            return
          }
          this.message = null
          this.$emit('getComments')
        })
        }
      }
      if(this.page.network == 'linkedin'){
        console.log('message :', this.message)  

        let senderidcom
        if(this.node.activity)
        senderidcom = this.node.activity
        if(this.node['$URN'])
        senderidcom = this.node['$URN']

        console.log('node activity linkedin : ', senderidcom)

        this.addComment(this.page, senderidcom, this.message).then(res => {
          this.$vs.loading.close(`#loadableContent-comments-${this.node.id} > .con-vs-loading`)
          const { success } = res.body

          if (!success || success !== true) {
            this.dialog.title = 'Error'
            if (!res.body) {
              this.dialog.message = 'Server not responding…'
            } else {
              this.dialog.message = res.body.statusText
            }
            this.dialog.show = true
            return
          }
          this.message = null
          this.$emit('getComments')
        })
      }

    },

    toggleEmojiPicker () {
      this.showEmojiPicker = !this.showEmojiPicker
    },
    hideEmojiPicker() {
      this.showEmojiPicker = false
    },
    addEmoji (emoji) {
      const input = this.$refs.inputTitle
      //console.log('refs', this.$refs)
      //console.log('input', input.$refs, input.selectionEnd, input.selectionStart)
      const cursorPosition = input.$refs.vsinput.selectionEnd
      this.message = this.message ? this.message : ''
      const start = this.message.substring(0, input.$refs.vsinput.selectionStart)
      const end = this.message.substring(input.$refs.vsinput.selectionStart)
      /*const cursorPosition = input.$refs.vstextarea.selectionEnd
      const start = this.message.substring(0, input.$refs.vstextarea.selectionStart)
      const end = this.message.substring(input.$refs.vstextarea.selectionStart)*/
      this.message = start + emoji.native + end
      input.focusInput()
      this.$nextTick(() => {
        input.$refs.vsinput.selectionEnd = cursorPosition + emoji.native.length
        //input.$refs.vstextarea.selectionEnd = cursorPosition + emoji.native.length
      })
    },
  },
computed: {
  getLinkedin()  {
     if(this.page.network == 'linkedin')
     return true
     else
     return false
   },

  }
}

</script>

<style scoped>
.textarea-emoji-picker {
  position: relative;
  margin: 0 auto;
}
.textarea {
  width: 100%;
  min-height: 300px;
  outline: none;
  box-shadow: none;
  padding: 10px 28px 10px 10px;
  font-size: 15px;
  border: 1px solid #BABABA;
  color: #333;
  border-radius: 2px;
  box-shadow: 0px 2px 4px 0 rgba(0,0,0,0.1) inset;
  resize: vertical;
}
.emoji-mart {
  position: absolute;
  top: 33px;
  right: 10px;
  z-index: 2;
}
.emoji-trigger {
  position: absolute;
  top: 6px;
  right: 10px;
  cursor: pointer;
  height: 20px;
  z-index: 1;
}
.emoji-trigger path {
  transition: 0.1s all;
}
.emoji-trigger:hover path {
  fill: #000000;
}
.emoji-trigger.triggered path {
  fill: darken(#FEC84A, 15%);
}
</style>